const FEATURES = [
  {
    title: 'Deal Pipeline & Dashboard',
    body: (
      <>
        Stay on top of every deal with <b>organized stages</b>, <b>automated</b>{' '}
        property data, and <b>sortable</b> views built for faster decisions.
      </>
    ),
    badge: null,
    img: 1,
  },
  {
    title: 'ARV Analysis',
    body: (
      <>
        ARV <b>estimates</b>, <b>comps</b>, <b>auto-adjustments</b>, <b>comp scoring</b>,
        and <b>market trends</b> delivered instantly.{' '}
        <span className="italic">Works in non-disclosure states.</span>
      </>
    ),
    badge: null,
    img: 2,
  },
  {
    title: 'Flip & BRRRR Projection',
    body: (
      <>
        <b>Score</b> deals, <b>compare</b> scenarios, <b>model</b> financing, and{' '}
        <b>track</b> key metrics. <b>Customize</b> templates to match your strategy.
      </>
    ),
    badge: null,
    img: 3,
  },
  {
    title: 'Rent Comps',
    body: (
      <>
        Rental <b>estimates</b>, <b>comps</b>, <b>pricing trends</b>, and{' '}
        <b>market composition</b> delivered instantly.
      </>
    ),
    badge: 'COMING SOON',
    img: 5,
  },
  {
    title: 'Deal Presentations',
    body: (
      <>
        Polished <b>PDF reports</b> that position you as the <b>expert</b> for
        buyers, partners, and lenders.
      </>
    ),
    badge: 'COMING SOON',
    img: 4,
  },
]

const FeatureBlock = ({ title, body, badge, img, imageLeft }) => {
  const image = (
    <img
      src={`/img-feature-${img}.png`}
      alt={title}
      className="w-[560px] object-contain select-none"
      draggable={false}
    />
  )
  const text = (
    <div className="w-[440px]">
      {badge && (
        <span className="inline-block px-3 py-1 rounded-full bg-brand-green text-white text-[12px] font-bold tracking-wider mb-4">
          {badge}
        </span>
      )}
      <h3 className="text-[28px] leading-[36px] font-extrabold text-brand-dark">{title}</h3>
      <p className="mt-4 text-[16px] leading-[26px] text-brand-dark/85">{body}</p>
    </div>
  )

  return (
    <div className="flex items-center justify-between gap-16">
      {imageLeft ? (
        <>
          {image}
          {text}
        </>
      ) : (
        <>
          {text}
          {image}
        </>
      )}
    </div>
  )
}

const Features = () => {
  return (
    <section className="bg-brand-pageFill">
      <div className="max-w-canvas mx-auto px-[120px] py-[120px]">
        <h2 className="text-[40px] leading-[48px] font-extrabold text-brand-dark text-center">
          Underwrite Deals{' '}
          <span className="text-brand-green">Faster</span>. Invest With{' '}
          <span className="text-brand-green">Confidence</span>.
        </h2>

        <div className="mt-20 flex flex-col gap-24">
          {FEATURES.map((feature, i) => (
            <FeatureBlock
              key={feature.title}
              {...feature}
              imageLeft={i % 2 === 0}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features
